import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLightning: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="lightning, zap, flash, thunder"><path d="M3.75 12.75L8.75 2.75H18L15.25 8.25H21.25L6.75 20.25L8.89706 12.75H3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconLightning;
